import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { HttpClient, HttpParams } from "@angular/common/http";
import { ProductMapping } from "../mappings/product/product-create/product-mappings";
import { IProductGetDtoModel } from "../models/product/dto/product-create/product-get-dto.model";
import { IProductModel } from "../models/product/product.model";
import { IProducPosttDtoModel } from "../models/product/dto/product-create/product-post-dto.model";
import { IPaginationRequestBaseModel } from "../models/generic/pagination/pagination-request.base.model";
import { IPaginationResponseModel } from "../models/generic/pagination/pagination-response.base.model";
import { IPaginationSearchRequestBaseModel } from "../models/generic/pagination/pagination-search-base.model";
import { ISearchProducts } from "../models/product/search/search.model";
import { EnvironmentService } from "./environment.service";


@Injectable({
    providedIn: 'root'
  })
export class MockProductService {
    fullPath!: string;

   constructor(private httpClient: HttpClient, public envService: EnvironmentService) {
      this.fullPath = `${envService.settings.apiUrl}/products`;
   }
   delete(model: IProductModel): Observable<boolean> {
   //   throw new Error("Method not implemented.");
   return of(true);
   }

   public update(mode: IProductModel): Observable<IProducPosttDtoModel> {
   //   throw new Error("Method not implemented.");
   return of({} as IProducPosttDtoModel);
   }

   public save(mode: IProducPosttDtoModel): Observable<IProducPosttDtoModel> {
      const prod = {} as IProducPosttDtoModel;
      return of({} as IProducPosttDtoModel);
   }

   public get(partNumber: string): Observable<IProductModel> {
      return of({} as IProductModel);
     // throw new Error('');
      // const productMapping = new ProductMapping();
      // return this.httpClient.get<IProductModel[]>(`${this.fullPath}?partNumber=${partNumber}`)
      //    .pipe(map(x => productMapping.toApplicationModel(x[0])))
   }

   public getAll(paginationModel: IPaginationRequestBaseModel): Observable<IPaginationResponseModel<IProductGetDtoModel>> {
      const productMapping = new ProductMapping();
     // const customerMapping = new CustomerMapping();
      return this.httpClient.get<IProductGetDtoModel[]>(this.fullPath).pipe(map(x => {
         return {
            total:  x.length,
            data: x
         } as IPaginationResponseModel<IProductGetDtoModel>
      }));
   }

   public search(paginationSearchModel: IPaginationSearchRequestBaseModel<ISearchProducts>): Observable<IPaginationResponseModel<IProductGetDtoModel>> {
      const mapping = new ProductMapping();
      let params = new HttpParams();

      if (paginationSearchModel != null) {
         if ( paginationSearchModel?.searchModel?.description) {
            params = params.append("description", paginationSearchModel?.searchModel?.description);
         }

         params = params.append("currentPage", paginationSearchModel.currentpage);
         params = params.append("rowsPerPage", paginationSearchModel.rowsperpage);
      }

      return this.httpClient.get<any>(this.fullPath,{ params } ).pipe(
         map(dtos => { 
            return {
            total: dtos.total,
            data: dtos.products? (dtos.products as IProductGetDtoModel[]): []
         } as IPaginationResponseModel<IProductGetDtoModel>
         })
      );

   }
}
